// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import api from '../../../../../../../services/api';

export const getVoucherDetailsService = async (data) => {
  return api(
    '/Sellitback.svc/VoucherDetails',
    data,
    'POST'
  );
};
